import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Link, Typography } from '@mui/material';

import Page from '@common/components/app-layout/page';
import PageContent from '@common/components/app-layout/page-content';
import UtilityHeader from '@common/components/app-layout/utility-header/utility-header';

const PageNotFound = ({ UtilityBar }) => {
  return (
    <>
      <UtilityHeader title="Page Not Found" UtilityBar={UtilityBar} hideBreadcrumbs />
      <Page>
        <PageContent pagePadding>
          <Typography variant="body2">
            We couldn&apos;t find that page. Return{' '}
            <Link to="/" underline="hover" component={RouterLink}>
              home
            </Link>
            .
          </Typography>
        </PageContent>
      </Page>
    </>
  );
};

export default PageNotFound;
